import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, TableCell } from '@mui/material';
import { Fragment } from 'react';
import { Controller, useFieldArray, useWatch } from 'react-hook-form';
var GroupPermissions = function (_a) {
    var groupIndex = _a.groupIndex, control = _a.control, setValue = _a.setValue;
    var fields = useFieldArray({
        control: control,
        name: "permissionGroups.".concat(groupIndex, ".permissions")
    }).fields;
    var permissions = useWatch({
        control: control,
        name: "permissionGroups.".concat(groupIndex, ".permissions")
    });
    var getPermissionDisabled = function (permissionIndex) {
        var isLastPermission = permissionIndex === fields.length - 1;
        if (isLastPermission)
            return false;
        var nextIndex = permissionIndex + 1;
        var validPermission = !!permissions[nextIndex].permissionName;
        if (validPermission)
            return permissions[nextIndex].isAssigned;
        else {
            while (!validPermission) {
                nextIndex = nextIndex + 1;
                validPermission = !!permissions[nextIndex].permissionName;
                if (nextIndex < permissions.length - 1)
                    return false;
            }
            return permissions[nextIndex].isAssigned;
        }
    };
    var onPermissionChanged = function (permissionIndex, isAssigned) {
        if (isAssigned)
            for (var i = 0; i <= permissionIndex; i++)
                setValue("permissionGroups.".concat(groupIndex, ".permissions.").concat(i, ".isAssigned"), true);
        else {
            if (permissionIndex === 0)
                for (var i = 0; i < fields.length; i++)
                    setValue("permissionGroups.".concat(groupIndex, ".permissions.").concat(i, ".isAssigned"), false);
        }
    };
    return (_jsxs(Fragment, { children: [fields.map(function (field, permissionIdex) { return (_jsx(Fragment, { children: !!!field.permissionName ? (_jsx(TableCell, { align: 'center', children: "---" })) : (_jsx(Controller, { name: "permissionGroups.".concat(groupIndex, ".permissions.").concat(permissionIdex, ".isAssigned"), control: control, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (_jsx(TableCell, { align: 'center', children: _jsx(Switch, { disabled: getPermissionDisabled(permissionIdex), checked: value, onChange: function (e) {
                                    onChange(e.target.checked);
                                    onPermissionChanged(permissionIdex, e.target.checked);
                                } }) }));
                    } })) }, permissionIdex)); }), fields.length < 4 && (_jsx(Fragment, { children: Array.from({ length: 4 - fields.length }, function (_, index) { return (_jsx(TableCell, { align: 'center', children: "---" }, index)); }) }))] }));
};
export default GroupPermissions;
